import { IGenericNewsItem } from '../types/GenericNewsItem';
import {
	INewsletterEntry,
	IPressReleaseEntry,
} from '../../../../../contentful';

export function mapNewsletter(newsletter: INewsletterEntry): IGenericNewsItem {
	return {
		id: newsletter.id,
		slug: newsletter.fields.slug,
		title: newsletter.fields.title,
		image: newsletter.fields.image,
		summary: newsletter.fields.summary,
		publicationDate: newsletter.fields.publicationDate,
		createdAt: newsletter.createdAt,
	};
}

export function mapPressRelease(
	pressRelease: IPressReleaseEntry,
): IGenericNewsItem {
	return {
		id: pressRelease.id,
		slug: pressRelease.fields.slug,
		title: pressRelease.fields.title,
		image: pressRelease.fields.image,
		summary: pressRelease.fields.body,
		publicationDate: pressRelease.fields.publicationDate,
		createdAt: pressRelease.createdAt,
		archived: pressRelease.fields.archived,
	};
}
